export enum UiMetric {
  SEEK_BY = 'seek_by',
}
